module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/floral-a97415aa87978b89a2e9531d58b8736d.jpg";